import { render, staticRenderFns } from "./editHotel.vue?vue&type=template&id=17160f24&scoped=true"
import script from "./editHotel.vue?vue&type=script&lang=js"
export * from "./editHotel.vue?vue&type=script&lang=js"
import style0 from "./editHotel.vue?vue&type=style&index=0&id=17160f24&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17160f24",
  null
  
)

export default component.exports